import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ParametroAzureAcsModel } from '../model/parametros/parametro-azure-acs.model';

@Injectable({ providedIn: 'root' })
export class ParametroAzureAcsService {
  private readonly http = inject(HttpClient);
  private readonly urlBase = `${environment.urlBase}/parametro-azure-acs`;

  buscar(): Observable<ParametroAzureAcsModel> {
    return this.http.get<ParametroAzureAcsModel>(this.urlBase);
  }

  salvar(parametro: ParametroAzureAcsModel): Observable<void> {
    return this.http.post<void>(this.urlBase, parametro);
  }
}
